module.exports = __webpack_public_path__ + "img/handasiah.48e2ccee.png";